import React from "react";
import { Google as GoogleIcon } from "mdi-material-ui";

const authProviders = [
  {
    id: "google.com",
    color: "#ea4335",
    icon: <GoogleIcon />,
    name: "Google",
  }
];

export default authProviders;
